import { bitrixChat } from '@/shared/integrations/BitrixChat'

export const useBitrixOperatorTransfer = (closeChat: () => void) => {
	const setDefaultCustomData = async (message: string) => {
		const customData = [
			{
				MESSAGE: `Последнее сообщение клиента ассистенту: ${message}`
			},
			{
				GRID: [
					{
						NAME: `Заголовок страницы`,
						VALUE: document.title,
						DISPLAY: `LINE`
					},
					{
						NAME: `Сайт`,
						VALUE: window.location.href,
						DISPLAY: `LINE`
					}
				]
			}
		]

		bitrixChat.setCustomData(customData)
	}

	const goToOperator = async (message: string) => {
		await setDefaultCustomData(message)
		closeChat()
		setTimeout(() => {
			bitrixChat.open()
		}, 100)
	}

	return { goToOperator }
}
